import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { useRef } from "react";

export default function SliderWithTitle({ blog }) {
  const progressCircle = useRef();
  const progressContent = useRef();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onAutoplayTimeLeft = (s, time, progress) => {
    if (progressCircle.current) {
      (progressCircle.current).style.setProperty(
        "--progress",
        `${1 - progress}`
      );
    }
    if (progressContent.current) {
      (progressContent.current).textContent = `${Math.ceil(
        time / 1000
      )}s`;
    }
  };
  return (
    <div>
      <Swiper
        effect={"fade"}
        navigation
        pagination={{ type: "bullets", clickable: true }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Autoplay, EffectFade, Pagination, Navigation]}
        onAutoplayTimeLeft={onAutoplayTimeLeft}
      >
        {blog.image.map((s, i) => (
          <SwiperSlide key={i}>
            <div className="w-full h-full relative">
              <img
                src={s.image}
                alt={s.title}
                className="!relative object-cover w-full h-full aspect-[5/3]"
              />
              <div className="absolute bottom-0 bg-black/35 w-full p-4">
                <p className="text-white">{s.title}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}

        <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20"></circle>
          </svg>
          <span ref={progressContent}></span>
        </div>
      </Swiper>
    </div>
  );
}
